
// ProfileCreationNew fetches user account data and provides it to nested routes via Outlet context
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import '../../stylesheets/backgrounds.css';

import Api from '../../Api';


function ProfileCreationNew() {
  // State to hold user account data
  const [data, setData] = useState(null);
  // React Router location object for detecting route changes
  let location = useLocation();

  // On route change, fetch account data and scroll to top
  useEffect(() => {
    let currentForm = location.pathname.split('/')[2]; // e.g., onboarding step
    handleLocationDataChange(currentForm);
    window.scrollTo(0, 0);
  }, [location]);

  // Fetch user account data from API and update state
  function handleLocationDataChange(dataKey: string) {
    Api.getAccount()
      .then((res) => {
        if (res.success) {
          let injectionData = res.response.data;
          setData(injectionData);
        } else {
          setData(null);
        }
      })
      .catch((err) => {
        setData(null);
      });
  }

  // Provide fetched data to nested routes via Outlet context
  return <Outlet context={{ data: data }} />;
}


export default ProfileCreationNew;
